import { Link } from "react-router-dom";

const steps = [
  { icon: "fa-envelope-open-text", title: "Instant Confirmation", desc: "Receive instant appointment confirmation via email" },
  { icon: "fa-bell", title: "Reminder Notifications", desc: "Get automated reminder notifications via email and SMS" },
  { icon: "fa-user-tie", title: "Meet Your Advisor", desc: "Meet with a financial strategy advisor from our team" },
  { icon: "fa-clipboard-check", title: "Customized Solutions", desc: "Review customized financial and business solutions" },
  { icon: "fa-rocket", title: "Actionable Next Steps", desc: "Discuss actionable next steps for financial growth and optimization" },
];

export const BookingPage = () => {
  return (
    <main data-testid="booking-page">
      {/* PAGE HERO */}
      <div className="pg-page-hero">
        <div className="pg-container">
          <span className="pg-label">Strategy Session</span>
          <h1>Choose Your Paradigm Global Strategy Session Time</h1>
          <p>Select a convenient time to meet with a Paradigm Global Business Solutions strategy professional.</p>
        </div>
      </div>

      {/* CALENDAR */}
      <section className="pg-section">
        <div className="pg-container">
          <div style={{
            maxWidth: 760, margin: "0 auto", background: "#fff", borderRadius: 20,
            boxShadow: "0 12px 40px rgba(0,0,0,.08)", padding: "2rem", overflow: "hidden"
          }}>
            <iframe
              src="https://api.leadconnectorhq.com/widget/booking/eD3fzSqRNf9sCR0R09gH"
              style={{ width: "100%", minHeight: "1100px", border: "none" }}
              scrolling="yes"
              id="eD3fzSqRNf9sCR0R09gH_1778906078974"
              title="Book a Strategy Session"
              data-testid="ghl-booking-calendar"
            />
          </div>

          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <p style={{ color: "var(--muted)", fontSize: ".85rem" }}>
              <i className="fas fa-lock" style={{ color: "var(--magenta)", marginRight: ".4rem" }} />
              Your session is completely free — no obligation, no pressure.
            </p>
          </div>
        </div>
      </section>

      {/* WHAT HAPPENS NEXT */}
      <section className="pg-section pg-section-light">
        <div className="pg-container">
          <div className="pg-text-center">
            <span className="pg-label">Your Journey</span>
            <h2>What Happens Next</h2>
            <div className="pg-divider" />
          </div>
          <div className="pg-steps-grid">
            {steps.map((s, i) => (
              <div key={s.title} style={{ textAlign: "center", padding: "1.5rem" }}>
                <div style={{
                  width: 60, height: 60, borderRadius: "50%", background: "var(--bg-pink)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  margin: "0 auto 1rem", color: "var(--magenta)", fontSize: "1.2rem"
                }}>
                  <i className={`fas ${s.icon}`} />
                </div>
                <div style={{
                  fontFamily: "'Playfair Display', serif", fontSize: "1.8rem",
                  background: "var(--grad)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                  backgroundClip: "text", fontWeight: 700, marginBottom: ".4rem"
                }}>
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h4 style={{ color: "var(--black)", marginBottom: ".3rem", fontSize: ".95rem" }}>{s.title}</h4>
                <p style={{ color: "var(--muted)", fontSize: ".85rem", margin: 0 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT ALT */}
      <section className="pg-cta-banner">
        <div className="pg-container">
          <h2>Prefer to Reach Out Directly?</h2>
          <p>Our team is ready to assist you with any questions.</p>
          <div className="pg-cta-btns">
            <a href="tel:+18635851412" className="pg-btn pg-btn-white">
              <i className="fas fa-phone" /> (863) 585-1412
            </a>
            <a href="mailto:info@financialfreedomdelivered.com" className="pg-btn pg-btn-outline-white">
              <i className="fas fa-envelope" /> Email Us
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BookingPage;
